(function ($) {
	$.sideMenu = function (element, options) {
		// **************************************************************
		// Public Properties
		// **************************************************************

		var $c = $(element), // Context 

			SideMenu = (function ($c, o) {
				var defaults = {

				}; 

				var _o = {},

					$mi = null, // Menu Items
					$mb = null, // Menu Back
					$cbt = null // Close Button
				;

				var _InitObjects = function () {
					_o = $.extend({}, defaults, o);

					$mi = $('.navigation a', $c);
					$mb = $('.side-navigation__back', $c);
					$cbt = $('.side-navigation__close', $c);
				},

					_OnMenuItemClick = function(e) {
						// e.preventDefault();
						// console.log('clicked');
					},
					
				_BindEvents = function () {
					$mi.click(_OnMenuItemClick);
				},

				init = (function() {
					_InitObjects();
					_BindEvents();
				})();
			}) ($c, options);
	};

	$.fn.sideMenu = function (options) {
		return this.each(function () {
			if (undefined === $(this).data('sideMenu')) {
				var plugin = new $.sideMenu(this, options);
				$(this).data('sideMenu', plugin);
			}
		});
	};
})(jQuery);
